import { Controller } from '@hotwired/stimulus';
import { convertToCurrency } from './currency';

export default class extends Controller {
  static targets = ['investor', 'amount'];

  update(event) {
    const { name, amount } = event.detail;

    this.investorTarget.textContent = name || '—';
    this.amountTarget.textContent = convertToCurrency(amount);
  }
}
